import React, { useEffect, useState, useMemo } from "react";
import "./../../../../assets/css/Dashboard/ServicesContainer.scss";
import { Tabs, Tab } from "@mui/material";
import ServicesListView from "./ServicesListView/ServicesListView";
import ServicesKanban from "./ServicesKanban/ServicesKanban";
import ServicesCalendar from "./ServicesCalendar/ServicesCalendar";
import ServicesAnalytics from "./ServicesAnalytics/ServicesAnalytics";
import ServicesDocuments from "./ServicesDocuments/ServicesDocuments";
import ServicesNewClinic from "./ServicesNewClinic/ServicesNewClinic";
import useTitanApp from "../../../../hooks/useTitanApp";
import commonData from "../../../../data/commonData";
import {
  getAnalyticsNMSProcessed,
  getAnalyticsServicesCompletedClaimed,
  getAnalyticsServicesCompletedToBeClaimed,
  getAnalyticsServicesCompletedToBeClaimedHistorical,
  getAnalyticsServicesDeclined,
  getAnalyticsServicesEarnings,
  getAnalyticsServicesStages,
  getAnalyticsServicesUsers,
  getHistoricalAnalyticsNMSProcessed,
  getHistoryAnalyticsServicesCompletedClaimed,
  setCurrentCompletedService,
  setFilterTagsData,
} from "../../../../dispatchers/pharmacyServiceDispatchers";
import { getAllDocuments } from "../../../../dispatchers/documentDispatchers";
import {
  getEvents,
  getServiceAnalytics,
  getPharmacyServices,
  setServiceTab,
  setCurrentCalendarDates,
  setCurrentServiceId,
  setShowCalender,
  setPharmacyServiceSidebarLoading,
  setShowNHSEmergencyKanban,
  getNHSEmergencyService,
  setIsNewClinicComponent,
  setPharmacyServiceLoading,
  getServiceProgress,
  getPharmacyClinicalServices,
  getPharmacyClinicalServicesCount,
} from "../../../../dispatchers/pharmacyServiceDispatchers";
import { setConsultationServiceCode } from "../../../../dispatchers/patientDispatchers";
import TravelVaccineModal from "../../../../components/TravelVaccineModal/TravelVaccineModal";
import ClinicalChecksModal from "../../../../components/ClinicalChecksModal/ClinicalChecksModal";
import PharmacyServicesDropdown from "../../../../components/PharmacyServicesDropdown/PharmacyServicesDropdown";
import { useNavigate, useParams } from "react-router";
import { setShowPatientSearchModal } from "../../../../dispatchers/appDispatchers";
import { RiDashboardFill } from "react-icons/ri";
import { FaRegUser } from "react-icons/fa";
import { LiaHistorySolid } from "react-icons/lia";
import { CiBoxList } from "react-icons/ci";
import { SlGraph } from "react-icons/sl";
import { FaApple } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import PatientDashboard from "../../../../components/PatientDashboard/PatientDashboard";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { PharmacySearchModal } from "../../../../components/ui/PharmacySearchModal";

function ServicesContainer({ handleUpdateServices }) {
  const {
    kanbanIcon,
    listviewIcon,
    analyticsIcon,
    documentIcon,
    calendarIcon,
  } = commonData || {};

  const {
    appState,
    pharmacyServiceState,
    darkMode,
    patientState,
  } = useTitanApp();
  const { currentPharmacyId } = appState || {};
  const { isPatientDashboard } = patientState || {};
  const [currentPatientTab, setCurrentPatientTab] = useState(0);
  const params = useParams();
  const { pharmacyId } = params || {
    pharmacyId: "00000000-0000-0000-0000-000000000000",
  };
  const {
    isCalenderShow,
    serviceName,
    serviceIcon,
    newClinicComponent,
    currentServiceId,
    currentServiceTab,
    currentServiceData,
    totalCount,
  } = pharmacyServiceState || {};

  const [isPatientFormModal, setIsPatientFormModal] = useState(false);

  useEffect(() => {
    setShowNHSEmergencyKanban(false);
  }, []);

  const handleChange = async (event, newValue) => {
    setServiceTab(newValue);
    switch (newValue) {
      case 2:
        setCurrentCompletedService("1");
        getEvents(currentPharmacyId, currentServiceId);
        break;
      case 3:
        setCurrentCalendarDates([null, null]);
        getAnalyticsNMSProcessed(currentPharmacyId, currentServiceId);
        getAnalyticsServicesEarnings(currentPharmacyId, currentServiceId);
        getAnalyticsServicesUsers(currentPharmacyId, currentServiceId);
        getAnalyticsServicesStages(currentPharmacyId, currentServiceId);
        getAnalyticsServicesCompletedClaimed(
          currentPharmacyId,
          currentServiceId,
        );
        getAnalyticsServicesCompletedToBeClaimed(
          currentPharmacyId,
          currentServiceId,
          "1",
        );

        getAnalyticsServicesCompletedToBeClaimedHistorical(
          currentPharmacyId,
          currentServiceId,
          "1",
        );
        getAnalyticsServicesDeclined(currentPharmacyId, currentServiceId);
        getHistoricalAnalyticsNMSProcessed(currentPharmacyId, currentServiceId);
        getHistoryAnalyticsServicesCompletedClaimed(
          currentPharmacyId,
          currentServiceId,
        );
        break;
      case 4:
        setCurrentCompletedService("1");
        getAllDocuments(currentPharmacyId, currentServiceId);
        break;
      case 1:
      default:
        setFilterTagsData([]);
        setCurrentCompletedService("1");
        getPharmacyServices(
          currentPharmacyId,
          0,
          currentServiceId,
          isCalenderShow,
        );

        break;
    }
  };

  const handlePatientTabChange = async (event, newValue) => {
    setCurrentPatientTab(newValue);
  };

  function shortenText(text, maxLength) {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength) + "...";
    }
    return text;
  }

  const tabIndicatorProps = useMemo(
    () => ({ style: { backgroundColor: "black" } }),
    [],
  );

  const handlePharmacySelect = (pharmacy) => {};

  const handleServiceDropdownChange = async (e) => {
    const serviceId = e.target.value;
    if (serviceId === currentServiceId) return;

    setServiceTab(0);
    setShowCalender(true);
    setPharmacyServiceSidebarLoading(true);
    setShowNHSEmergencyKanban(false);
    setIsNewClinicComponent(false);
    setPharmacyServiceLoading(true);

    if (serviceId === "0") {
      setCurrentServiceId("0");
      try {
        await Promise.all([
          getPharmacyServices(pharmacyId, 0, 0, true),
          getPharmacyClinicalServices(pharmacyId),
          getPharmacyClinicalServicesCount(pharmacyId),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setPharmacyServiceLoading(false);
      }
      return;
    }

    const selected = currentServiceData?.find((s) => s.serviceID === serviceId);
    if (!selected) return;

    setCurrentServiceId(serviceId);

    if (selected.serviceCode === 17) {
      setShowNHSEmergencyKanban(true);
      setPharmacyServiceLoading(false);
      try {
        await getNHSEmergencyService(currentPharmacyId);
        setConsultationServiceCode(selected.serviceCode);
      } catch (error) {
        console.error(error);
      }
    } else {
      try {
        await Promise.all([
          getPharmacyServices(pharmacyId, 0, serviceId, true),
          getServiceProgress(serviceId, pharmacyId),
          getPharmacyClinicalServices(pharmacyId),
          getPharmacyClinicalServicesCount(pharmacyId),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setPharmacyServiceLoading(false);
      }
    }
  };

  return (
    <div className="services_container">
      {isPatientFormModal && (
        <TravelVaccineModal
          show={isPatientFormModal}
          setShow={setIsPatientFormModal}
        />
      )}
      {newClinicComponent ? (
        <ServicesNewClinic handleUpdateServices={handleUpdateServices} />
      ) : (
        <>
          <div className="services_container_wrapper">
            <div className="tabs_box services_container-tabs">
              {!isPatientDashboard && (
                <>
                  {/* <PharmacyServicesDropdown /> */}
                  <select
                    className="flex items-center gap-2 px-3 py-2 text-sm font-medium transition-all duration-200 border rounded-lg"
                    value={currentServiceId || "0"}
                    onChange={handleServiceDropdownChange}
                  >
                    {currentServiceData?.map((service) => (
                      <option key={service.serviceID} value={service.serviceID}>
                        {service.name}
                        {service.total != null ? ` (${service.total})` : ""}
                      </option>
                    ))}
                  </select>
                  {/* <PharmacySearchModal
                    trigger={
                      <Button
                        size="sm"
                        variant="outline"
                         className={`flex items-center gap-2 ${
                    darkMode
                      ? "border-gray-600 text-gray-200 hover:bg-gray-700"
                      : "border-gray-200 text-gray-700 hover:bg-gray-50"
                  }`}
                      >
                  <Search className="w-4 h-4" />
                        Search for Pharmacy
                      </Button>
                    }
                    // onSelect={setSelectedPharmacy}
                    onSelect={handlePharmacySelect}
                    isDarkMode={darkMode}
                    defaultPostcode={""}
                    showServiceTypeFilter={true}
                  /> */}
                  <Tabs
                    value={currentServiceTab}
                    onChange={handleChange}
                    aria-label="Tabs"
                    TabIndicatorProps={tabIndicatorProps}
                  >
                    <Tab
                      icon={kanbanIcon}
                      iconPosition="start"
                      label={<span className={`tabs_text`}>Kanban</span>}
                    />

                    <Tab
                      icon={listviewIcon}
                      iconPosition="start"
                      label={<span className={`tabs_text`}>List</span>}
                    />

                    {isCalenderShow && (
                      <Tab
                        icon={calendarIcon}
                        iconPosition="start"
                        label={<span className={`tabs_text`}>Calendar</span>}
                      />
                    )}

                    {isCalenderShow && (
                      <Tab
                        icon={analyticsIcon}
                        iconPosition="start"
                        label={<span className={`tabs_text`}>Analytics</span>}
                      />
                    )}

                    {isCalenderShow && (
                      <Tab
                        icon={documentIcon}
                        iconPosition="start"
                        label={<span className={`tabs_text`}>Documents</span>}
                      />
                    )}

                    {/*Add View Button */}
                    {/* <div className="add-view-btn">
                  <p>Add View</p> <GoPlus color="#666" />
                </div> */}
                  </Tabs>
                </>
              )}

              {/* <button
                className="kanban-control-btn service-consultation-btn"
                onClick={() => {
                  setShowPatientSearchModal(true);
                  //navigate("/serviceConsultation");
                }}
              >
                <p>Service Consultation</p>
              </button> */}
            </div>
          </div>

          <div className="services_container-content-area">
            {currentServiceTab === 1 ? (
              <ServicesListView
                setIsPatientFormModal={setIsPatientFormModal}
                handleChange={handleChange}
              />
            ) : currentServiceTab === 2 ? (
              <ServicesCalendar />
            ) : currentServiceTab === 3 ? (
              <ServicesAnalytics />
            ) : currentServiceTab === 4 ? (
              <ServicesDocuments />
            ) : (
              <ServicesKanban
                setIsPatientFormModal={setIsPatientFormModal}
                handleChange={handleChange}
              />
            )}
          </div>
        </>
      )}
      <ClinicalChecksModal />
    </div>
  );
}
export default React.memo(ServicesContainer);
